import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from '../../../../middlewares/api/actions';
import { combineReducers } from 'redux';
import loaderCsvFormMappingControlReducer from './mapping-control/reducer';
import {
  LOADER_CSV_FORM_MAPPING_CONTROL_CODELIST_CODES_ITEMS_PAGE_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_MODIFIED_SET,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET,
  LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UPDATE,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_READ,
  LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET,
  LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET_INDEX,

} from './mapping-control/actions';
import {
  LOADER_CSV_FORM_CHANGE,
  LOADER_CSV_FORM_FILE_UPLOAD,
  LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE,
  LOADER_CSV_FORM_PLUGIN_CONVERT,
  LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT,
  LOADER_CSV_FORM_SUBMIT,
  LOADER_HIDE_MODAL_REVIEW_DATAFLOWS,
  LOADER_PLUGIN_FILE_UPLOAD, LOADER_RESET_FIELDS,
  LOADER_SHOW_MODAL_REVIEW_DATAFLOWS,
  LOADER_UPLOAD_DATAFLOW_BUILDER
} from './actions';
import _ from 'lodash';
import loaderCsvFormRowListReducer from './row-list/reducer';
import { userMustNotInsertTid } from './utils';
import { LOADER_FORMAT_SET } from "../actions";
import { getSequenceMappingMappings } from '../../file-mapping/list/utils';
import { CODELIST_ORDER_ANNOTATION_KEY, getItemSchemeFromSdmxJsonFactory, getSdmxStructuresFromSdmxJson, SDMX_JSON_CODELIST_ITEMS_KEY } from '../../../../utils/sdmxJson';
import { getCurrentNodeConfig } from '../../../../middlewares/current-node-config/middleware';

const loaderCsvFormReducer = combineReducers({
  components: combineReducers({
    mappingControl: loaderCsvFormMappingControlReducer,
    rowList: loaderCsvFormRowListReducer
  }),
  shared: (
    state = {
      mappingId: null,
      mapping: null,
      mappingCube: null,
      tid: null,
      separator: null,
      delimiter: null,
      hasHeader: false,
      hasDotStatFormat: null,
      fileServerPath: null,
      csvServerPath: null,
      selectedMappingIsSequence: false,
      seqMappings: null,
      seqMappingsIndex: -1,
      prevSeqMappingIndex: 0,
      componentCodelistCodesItemsPage: null,
      componentCodelistCodesItemsCount: null,
      configuredPlugin: null,
      mappingIsModified: false,
      secondServerPath: null,
      thirdServerPath: null,
      transformFileInput: null,
      processFileInput: null,
      deleteMode: false,
      hasMappingFieldExpressions: false,
      showModalDataflowsReview: false
    },
    action
  ) => {
    switch (action.type) {
      case LOADER_UPLOAD_DATAFLOW_BUILDER:
        return {
          ...state
        }
      case LOADER_SHOW_MODAL_REVIEW_DATAFLOWS:
        return {
          ...state,
          showModalDataflowsReview: true
        };
      case LOADER_HIDE_MODAL_REVIEW_DATAFLOWS:
          return {
            ...state,
            showModalDataflowsReview: false
          };
      case LOADER_FORMAT_SET:
        return {
          mappingId: null,
          mapping: null,
          mappingCube: null,
          tid: null,
          separator: null,
          delimiter: null,
          hasHeader: false,
          hasDotStatFormat: null,
          fileServerPath: null,
          csvServerPath: null,
          selectedMappingIsSequence: false,
          seqMappings: null,
          seqMappingsIndex: -1,
          componentCodelistCodesItemsPage: null,
          componentCodelistCodesItemsCount: null,
          mappingIsModified: false,
          deleteMode: false
        };
      case LOADER_CSV_FORM_CHANGE:
        const {
          mappingId,
          tid,
          separator,
          delimiter,
          hasHeader,
          hasDotStatFormat,
          file,
          configuredPlugin,
          transformFileInput,
          processFileInput,
          deleteMode,
        } = _.mapValues(action.fields, field => field.value);
        return {
          ...state,
          tid: tid !== undefined ? tid : state.tid,
          separator: separator !== undefined ? separator : state.separator,
          delimiter: delimiter !== undefined ? delimiter : state.delimiter,
          hasHeader: hasHeader !== undefined ? hasHeader : state.hasHeader,
          hasDotStatFormat: hasDotStatFormat !== undefined ? hasDotStatFormat : state.hasDotStatFormat,
          fileServerPath: (mappingId !== undefined || file !== undefined || separator !== undefined || delimiter !== undefined || hasHeader !== undefined)
            ? null
            : state.fileServerPath,
          csvServerPath: (mappingId !== undefined || file !== undefined || separator !== undefined || delimiter !== undefined || hasHeader !== undefined)
            ? null
            : state.csvServerPath,
          configuredPlugin: configuredPlugin !== undefined ? configuredPlugin : state.configuredPlugin,
          transformFileInput: transformFileInput !== undefined ? transformFileInput : state.transformFileInput,
          processFileInput: processFileInput !== undefined ? processFileInput : state.processFileInput,
          deleteMode: deleteMode ? deleteMode : state.deleteMode
        };

      case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_SET:
        return {
          ...state,
          mappingId: action.mappingId,
          tid: null,
          selectedMappingIsSequence: false,
        };
      case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET:
        return {
          ...state,
          mappingId: null,
          mapping: null,
          mappingCube: null,
          fileServerPath: null,
          csvServerPath: null,
          separator: null,
          delimiter: null,
          hasDotStatFormat: null,
          hasHeader: false,
          tid: null,
          selectedMappingIsSequence: false,
          seqMappings: null,
          seqMappingsIndex: -1,
          componentCodelistCodesItemsPage: null,
          componentCodelistCodesItemsCount: null,
          mappingIsModified: false,
          deleteMode: false
        };
      case LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET:
        return {
          ...state,
          mappingId: action.sequenceMappingId,
          selectedMappingIsSequence: true,
          tid: null,
        };
      case LOADER_CSV_FORM_MAPPING_CONTROL_SEQUENCE_MAPPING_SET_INDEX: {
        return {
          ...state,
          seqMappingsIndex: action.index,
        }
      }
      case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_MODIFIED_SET: {
        return {
          ...state,
          mappingIsModified: action.value,
        }
      }
      case LOADER_RESET_FIELDS:
        return {
          ...state,
          fileServerPath: null,
          secondServerPath: null,
          thirdServerPath: null,
          csvServerPath: null,
          tid: null,
          mapping: null,
          mappingId: null,
          mappingCube: null,
          seqMappings: null,
          seqMappingsIndex: -1,
          componentCodelistCodesItemsPage: null,
          componentCodelistCodesItemsCount: null,
          mappingIsModified: false,
          deleteMode: false
        }
      case REQUEST_START:
        switch (action.label) {
          case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ:
          case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_READ:
            return {
              ...state,
              tid: null,
              mapping: null,
              seqMappings: null,
              seqMappingsIndex: -1,
              componentCodelistCodesItemsPage: null,
              componentCodelistCodesItemsCount: null,
              mappingIsModified: false,
            };
          case LOADER_CSV_FORM_FILE_UPLOAD:
            return {
              ...state,
              fileServerPath: null,
              csvServerPath: null
            };
          case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ:
            return {
              ...state,
              tid: null,
              mappingCube: null,
            };
          default:
            return state;
        }
      case REQUEST_SUCCESS: {
        switch (action.label) {
          case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_READ:
            return {
              ...state,
              mapping: action.response,
              separator: action.response.CSVSeparator,
              delimiter: action.response.CSVDelimiter,
              hasHeader: action.response.HasHeader,
              hasDotStatFormat: action.response.HasSpecialTimePeriod,
              seqMappings: null,
              seqMappingsIndex: -1,
              componentCodelistCodesItemsPage: null,
              componentCodelistCodesItemsCount: null,
              mappingIsModified: false,
              hasMappingFieldExpressions: action.response.HasFieldExpressions
            };
          case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_MAPPING_CUBE_READ:
            return {
              ...state,
              tid:
                !userMustNotInsertTid(state.mapping, action.response) &&
                  !state.mapping.Tid ? null : state.mapping.Tid,
              mappingCube: action.response,
              componentCodelistCodesItemsPage: null,
              componentCodelistCodesItemsCount: null,
            };
          case LOADER_CSV_FORM_FILE_UPLOAD:
            return {
              ...state,
              fileServerPath: action.response,
              csvServerPath: action.format === 'csv' ? action.response : null
            };
          case LOADER_PLUGIN_FILE_UPLOAD:
            const fileServerPath = Array.isArray(action.response) ? action.response[0] : action.response;
            const secondServerPath = Array.isArray(action.response) ? action.response[1] : null;
            const thirdServerPath = Array.isArray(action.response) && action.response.length > 2 ? action.response[2] : null;
            return {
              ...state,
              fileServerPath,
              secondServerPath,
              thirdServerPath
            };
          case LOADER_CSV_FORM_SUBMIT:
          case LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT:
            return {
              mappingId: null,
              mapping: null,
              mappingCube: null,
              tid: null,
              separator: null,
              delimiter: null,
              hasDotStatFormat: null,
              hasHeader: false,
              fileServerPath: null,
              csvServerPath: null,
              selectedMappingIsSequence: false,
              seqMappings: null,
              seqMappingsIndex: -1,
              componentCodelistCodesItemsPage: null,
              componentCodelistCodesItemsCount: null,
              mappingIsModified: false,
              deleteMode: false
            };
          case LOADER_CSV_FORM_MAPPING_CONTROL_SELECTED_SEQUENCE_MAPPING_READ: {
            const mapping = action.response;
            const mappingsTree = action.mappingsTree;
            const seqMappings = getSequenceMappingMappings(mapping, mappingsTree);
            return {
              ...state,
              mapping: mapping,
              seqMappings: seqMappings,
              seqMappingsIndex: 0,
              separator: null,
              delimiter: null,
              hasHeader: null,
              hasDotStatFormat: null,
              componentCodelistCodesItemsPage: null,
              componentCodelistCodesItemsCount: null,
              mappingIsModified: false,
            };
          }
          case LOADER_CSV_FORM_MAPPING_CONTROL_CODELIST_CODES_ITEMS_PAGE_READ: {

            const codes = getItemSchemeFromSdmxJsonFactory(
              SDMX_JSON_CODELIST_ITEMS_KEY,
              getCurrentNodeConfig(action).annotations,
              CODELIST_ORDER_ANNOTATION_KEY
            )(getSdmxStructuresFromSdmxJson(action.response)[0]).codes || [];

            const isInvisibleItem = item => {
              return item.annotations && (
                item.annotations.find(annot =>
                  annot.id === "INVISIBLE" &&
                  annot.title === "INVISIBLE" &&
                  annot.type === "INVISIBLE"
                ) !== undefined
              );
            };

            const component = [...state.mappingCube.Attributes, ...state.mappingCube.Dimensions].find(c => c.Code === action.componentName);
            const componentCodes = component.codes;

            const codelistCodesItemsPage = codes
              .filter(item => !isInvisibleItem(item))
              .filter(item => componentCodes.includes(item.id));

            return {
              ...state,
              componentCodelistCodesItemsPage: codelistCodesItemsPage,
              componentCodelistCodesItemsCount: Number(action.header["x-total-count"]),
            };
          }
          case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UPDATE:
            const newMapping = _.cloneDeep(action.data);
            newMapping.IDMapping = action.response;
            return {
              ...state,
              mappingId: action.response,
              mapping: newMapping,
              mappingIsModified: false,
            };
          case LOADER_CSV_FORM_PLUGIN_CONVERT: {
            return {
              ...state,
              csvServerPath: action.response.outputFilePath,
              separator: action.response.csvSeparator || ",",
              delimiter: (action.response.csvDelimiter === "\n" ? null : action.response.csvDelimiter) || null,
              hasHeader: action.response.csvHasHeader || false,
              prevSeqMappingIndex: state.seqMappingsIndex,
            }
          }
          default:
            return state;
        }
      }
      default:
        return state;
    }
  },
  local: (
    state = {
      importType: "SeriesAndData",
      file: null,
      embargo: {
        enabled: false,
        autoReleaseEnabled: false,
        autoReleaseDate: null,
        autoReleaseTime: null,
        refreshProdDf: false
      },
      isIgnoreConcurrentUploadConfirmVisible: false,
      checkFiltAttributes: true
    },
    action
  ) => {
    switch (action.type) {
      case LOADER_FORMAT_SET:
        return {
          importType: "SeriesAndData",
          file: null,
          embargo: {
            enabled: false,
            autoReleaseEnabled: false,
            autoReleaseDate: null,
            autoReleaseTime: null,
          },
          refreshProdDf: false,
          checkFiltAttributes: true
        };
      case LOADER_CSV_FORM_CHANGE:
        let {
          importType,
          file,
          embargo,
          refreshProdDf,
          checkFiltAttributes,
          configuredPlugin
        } = _.mapValues(action.fields, field => field.value);
        return {
          ...state,
          importType: importType !== undefined ? importType : state.importType,
          file: file !== undefined ? file : state.file,
          embargo: embargo !== undefined ? embargo : state.embargo,
          refreshProdDf: refreshProdDf !== undefined ? refreshProdDf : state.refreshProdDf,
          checkFiltAttributes: checkFiltAttributes !== undefined ? checkFiltAttributes : state.checkFiltAttributes,
          configuredPlugin: configuredPlugin !== undefined ? configuredPlugin : state.configuredPlugin
        };
      case LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE:
        return {
          ...state,
          isIgnoreConcurrentUploadConfirmVisible: false
        };
      case LOADER_CSV_FORM_MAPPING_CONTROL_MAPPING_UNSET:
        return {
          ...state,
          tid: null,
          file: null,
          embargo: {
            enabled: false,
            autoReleaseEnabled: false,
            autoReleaseDate: null,
            autoReleaseTime: null,
          },
          refreshProdDf: false,
          checkFiltAttributes: true
        };
      case REQUEST_SUCCESS: {
        switch (action.label) {
          case LOADER_CSV_FORM_SUBMIT:
          case LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT:
            return {
              ...state,
              importType: "SeriesAndData",
              file: null,
              isVisible: false,
              refreshProdDf: false,
              checkFiltAttributes: true,
              deleteMode: false
            };
          default:
            return state;
        }
      }
      case REQUEST_ERROR: {
        switch (action.label) {
          case LOADER_CSV_FORM_SUBMIT:
          case LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT:
            if (action.error && action.error.errorCode === "LOADING_CONCURRENT_UPLOAD_SAME_CUBE") {
              return {
                ...state,
                isIgnoreConcurrentUploadConfirmVisible: true
              }
            } else {
              return state;
            }
          default:
            return state;
        }
      }
      default:
        return state;
    }
  }
});

export default loaderCsvFormReducer;
